// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateFolderNameReducer extends Reducer
{
	public static reducerName: string = "UpdateFolderName";
	public static call(_folderId: number, _name: string) {
		this.getReducer().call(_folderId, _name);
	}

	public call(_folderId: number, _name: string) {
		const serializer = this.client.getSerializer();
		let _folderIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_folderIdType, _folderId);
		let _nameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_nameType, _name);
		this.client.call("UpdateFolderName", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let folderIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let folderIdValue = AlgebraicValue.deserialize(folderIdType, adapter.next())
		let folderId = folderIdValue.asNumber();
		let nameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let nameValue = AlgebraicValue.deserialize(nameType, adapter.next())
		let name = nameValue.asString();
		return [folderId, name];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _folderId: number, _name: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _folderId: number, _name: string) => void)
	{
		this.client.on("reducer:UpdateFolderName", callback);
	}
}


export default UpdateFolderNameReducer
